import type {ReactNode} from "react";

import {PublicPageShell} from "@/src/modules/core/components";
import {LOGO_URL_DESKTOP} from "@/src/modules/core/utils/constants";

type ClaimPublicShellProps = {
  title: string;
  children: ReactNode;
};

export default function ClaimPublicShell({title, children}: ClaimPublicShellProps) {
  return (
    <PublicPageShell>
      <div className="rounded-lg bg-background p-6 shadow-lg sm:p-8">
          <div className="mb-8 flex flex-col items-center">
            <div className="flex size-16 items-center justify-center rounded-full">
              <img src={LOGO_URL_DESKTOP} alt="STARSPRO" height="100" />
            </div>
            <h1 className="text-2xl font-bold text-foreground">STARSPRO</h1>
            <p className="text-muted-foreground">Security Management System</p>
          </div>

          <h2 className="mb-6 text-center text-xl font-semibold text-foreground">{title}</h2>

          {children}
        </div>

      <div className="mt-6 text-center text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} STARSPRO. All rights reserved.
      </div>
    </PublicPageShell>
  );
}
